import { useState } from 'react';
import { createPortal } from 'react-dom';
import VBTextarea from '@vb-js-commons/new/vbTextarea';
import { TwModal, Button, Icon } from '@ui-component-library';
import { createSimpleBidNew, selectWinningBidNew } from '../../api/services/ad';

const AdPlaceBidSection = ({ toggle_loading, scrollCallback }) => {
    const hashBidMatch = window.location.hash.match(/show_bids\/(\d+)/);
    const [ad, setAd] = useState(Window.react_data.ad);
    const [visiblePlaceBidModal, setVisiblePlaceBidModal] = useState(false);
    const [visibleShowBidsModal, setVisibleShowBidsModal] = useState(window.location.hash.includes('show_bids'));
    const [openBids, setOpenBids] = useState(hashBidMatch ? [Number(hashBidMatch[1])] : []);
    const [tempFiles, setTempFiles] = useState([]);
    const [bidText, setBidText] = useState("");
    const [showSellerContactModal, setShowSellerContactModal] = useState(false);

    //Helpers
    const handleUploadFiles = (e) => {
        const files = Array.from(e.target.files);
        setTempFiles(prev => [...prev, ...files]);
    };

    //   Api's
    const placeBid = async () => {
        setVisiblePlaceBidModal(false);
        toggle_loading();
        const response = await createSimpleBidNew(bidText, tempFiles, ad.id);
        if (response.ok) {
            window.location.reload();
        } else {
            console.error("Error creating bid");
        }
    };

    const selectWinningBid = async (bidId) => {
        toggle_loading();
        const response = await selectWinningBidNew(bidId)
        if (response.ok) {
            window.location.reload();
        } else {
            console.error("Error selecting bid");
        }
    }

    // Render functions

    const renderAdDetailsStateBar = () => {
        const isOwner = Window.user_data.loggedInUserID === ad.ad_user;
        const isWinner = ad.winning_bid_user === Window.user_data.loggedInUserID;
        const hasBidded = ad.current_user_has_bidded;
        const isAdmin = Window.user_data.isAdmin;

        let icon = "img/icons/icon-center.svg";
        let color = "success-500";
        let text = "";
        let extra = null;

        if (ad.state_name === "WAITING_FOR_REVIEW") {
            color = "warning-500";
            text = "Din virkesannons granskas av Treebula";

        } else if (["AUCTION_READY", "PENDING_RESPONSE"].includes(ad.state_name)) {
            icon = "img/icons/check-circle.svg";

            if (ad.auction_in_future) {
                text = `${isOwner ? "Din virkesannons" : "Den här virkesannonsen"} öppnas för anbud ${ad.start_time}`;
            } else if (ad.auction_is_live) {
                text = `${isOwner ? "Din virkesannons" : "Den här virkesannonsen"} är öppen för anbud`;
            } else if (ad.auction_is_over) {
                if (hasBidded) {
                    text = "Säljaren väljer köpare";
                } else if (isOwner && ad.bids_visible.length !== 0) {
                    text = "Klicka på knappen nedan för att se dina anbud och välja köpare";
                } else {
                    text = "Denna affär är avslutad:";
                }
            }

        } else if (ad.state_name === "NO_BID_SELECTED") {
            icon = "img/icons/Warning.svg";
            color = "warning-500";
            text = "Säljaren valde att avvakta och valde inget anbud på plattformen";

        } else if (ad.state_name === "WINNER_SELECTED") {
            icon = "img/icons/check-circle.svg";
            text = "Denna affär är avslutad";

            if (isOwner) {
                text = "Du har valt köpare - Köparen kommer att kontakta dig för fortsatt dialog, nästa steg och kontraktskrivning";
            } else if (isWinner) {
                text = "Du har blivit vald som köpare - kontakta skogsägaren för fortsatt dialog, nästa steg och kontraktskrivning";
            } else if (hasBidded && !isWinner) {
                icon = "img/icons/XCircle.svg";
                color = "warning-500";
                text = "Du har tyvärr inte valts som köpare";
            }

        } else if (ad.state_name === "CONTRACT_CREATED") {
            icon = "img/icons/check-circle.svg";
            text = "Treebula granskar virkesaffären";

            if (ad.signing_method === ad.SIGNING_ON_PAPER) {
                if (isWinner || isOwner) {
                    text = "Affären signeras på papper.";
                    extra = (
                        <a className='underline font-bold mr-4' href={ad.contractPdf_URL}>
                            Ladda ned kontraktet
                        </a>
                    );
                } else if (hasBidded) {
                    icon = "img/icons/icon-center.svg";
                    color = "warning-500";
                    text = "Du valdes tyvärr inte som köpare";
                }
            } else if (ad.contract !== "SIGNED") {
                text = "Treebula hanterar signering av kontrakt";
            } else if (isWinner || isOwner) {
                text = "Affären är avslutad.";
                extra = (
                    <a className='underline font-bold mr-4' href={ad.contractPdf_URL}>
                        Ladda ned kontraktet.
                    </a>
                );
            }

        } else if (ad.state_name === "DRAFT" && ad.ad_isFullService) {
            color = "warning-500";
            text = "Treebula arbetar med att ta fram din annons";

        } else if (ad.state_name === "CREATED" && isOwner) {
            text = "Du granskar din annons";

        } else if (ad.state_name === "DRAFT" && isAdmin) {
            color = "warning-500";
            text = "Annonsen är under bearbetning.";

        } else if (ad.state_name === "KREDITED") {
            color = "warning-500";
            text = "Affären blev inte av";

        } else if (ad.state_name == "NO_BID"){
            color = "warning-500";
            text = "Affären fick inget anbud på plattformen";

        } else if (ad.state_name == "NO_BID_SELECTED"){
            color = "warning-500";
            text = "Säljaren valde inget anbud på plattformen";

        } 
        else if (isAdmin) {
            icon = "img/icons/Warning.svg";
            text = `Annonsen är ${ad.state_name === "INACTIVE" ? "inaktiv." : "ej redo för auktion."}`;
        } else {
            return null;
        }

        return (
            <>
                {!Window.react_data.trustedBuyer && (
                    <p className='mt-2'>
                        Eftersom du inte är ansluten köpare, måste du kontakta oss på{" "}
                        <a className="underline font-bold" style={{ cursor: 'pointer' }} href="mailto:information@treebula.se">
                            information@treebula.se
                        </a>{" "}
                        för att se all information.
                    </p>
                )}

                {text && (
                    <div className="flex flex-row justify-start items-center gap-4">
                        <img
                            src={`${Window.static_path}${icon}`}
                            className={`rounded-full p-1 bg-${color}`}
                            height="32px"
                            width="32px"
                            alt="Status Icon"
                        />
                        <p className="fs-5 font-medium mb-0">{text}</p>
                    </div>
                )}
                {extra && (<div>{extra}<hr className="bg-neutral-charcoal border-gray-300 my-3" /></div>)}
            </>
        );
    };

    const renderAdsDetailsCTA = () => {
        const isOwner = Window.user_data.loggedInUserID === ad.ad_user;
        const isAdmin = Window.user_data.isAdmin;
        const isLive = ad.auction_is_live;
        const isOver = ad.auction_is_over;
        const hasBids = ad.bids_visible.length !== 0;
        const isARorPR = ad.state_name === 'AUCTION_READY' || ad.state_name === "PENDING_RESPONSE";
        const hasUserBid = ad.current_user_has_bidded || ad.child_account_did_bid;

        const renderBidButton = () => (
            <button className="n-btn btn-charcoal whitespace-nowrap w-full flex items-center justify-center cursor-pointer my-2" style={{ minWidth: '100px' }} onClick={() => setVisibleShowBidsModal(true)}>
                Se dina anbud
                <span>
                    <img className="ml-2 primary-core-filter" style={{ width: "16px", height: "16px" }} src={`${Window.static_path}img/icons/arrow-black.svg`} />
                </span>
            </button>
        );

        if (!isOwner && isLive) {
            return (
                <div className="flex flex-col items-center">
                    <hr className="w-full my-3 border-gray-300" />
                    {ad.seller_contact ? (
                        <>
                            <button
                                type="button"
                                className="n-btn btn-outline btn-charcoal whitespace-nowrap w-full mb-2 cursor-pointer"
                                style={{ minWidth: '100px' }}
                                onClick={() => setShowSellerContactModal(true)}
                            >
                                Visa kontaktuppgifter skogsägare
                            </button>
                            <p className="text-center fs-7 my-2">eller</p>
                        </>
                    ) : null}
                    <button className="n-btn btn-forest-green whitespace-nowrap w-full cursor-pointer" style={{ minWidth: '100px' }} onClick={() => setVisiblePlaceBidModal(true)}>
                        Lämna anbud via formulär
                    </button>
                    <p className="text-center fs-7 my-2">eller</p>
                    <a className="n-btn btn-forest-green btn-outline whitespace-nowrap w-full" style={{ minWidth: '100px' }} href={`mailto:anbud@treebula.se?subject=Anbud på annons #${ad.id}`}>
                        Lämna anbud via mail
                    </a>
                    <hr className="w-full my-3 border-gray-300" />

                    <div className="bg-neutral-stone-300 p-2" style={{ borderRadius: "8px" }}>
                        <p className="mt-2">
                            Du kan även maila ditt anbud till <a className="underline font-bold" href={`mailto:anbud@treebula.se?subject=Anbud på annons #${ad.id}`}>anbud@treebula.se</a>.
                        </p>
                        <p>Ange annonsnummer #{ad.id}.</p>
                    </div>

                    {(hasUserBid || isAdmin) && (
                        <>
                            <hr className="w-full my-3 border-gray-300" />
                            {renderBidButton()}
                        </>
                    )}

                    <hr className="w-full my-3 border-gray-300" />
                </div>
            );
        }

        if (isOwner && isARorPR && isOver && hasBids) {
            return (
                <div className="flex flex-col items-center">
                    <hr className="w-full my-3 border-gray-300" />
                    <button className="n-btn btn-forest-green whitespace-nowrap w-full mb-6 cursor-pointer" style={{ minWidth: '100px' }} onClick={() => setVisibleShowBidsModal(true)}>
                        Välj köpare
                        <span>
                            <img className="ml-2 white-filter" style={{ width: "16px", height: "16px" }} src={`${Window.static_path}img/icons/arrow-black.svg`} />
                        </span>
                    </button>
                </div>
            );
        }

        if (isOwner && isARorPR && isOver && !hasBids) {
            return (
                <div className="flex items-start justify-center">
                    <p className="text-center mb-0 subtitle font-bold">Om du har frågor kontakta{" "}
                        <a className="underline font-bold cursor-pointer" href="mailto:information@treebula.se">
                            information@treebula.se
                        </a>
                    </p>
                </div>
            );
        }

        if (isAdmin || hasUserBid || (isOwner && hasBids)) {
            return (
                <div className="w-full flex flex-col items-center">
                    <hr className="w-full my-3 border-gray-300" />
                    {renderBidButton()}
                    <hr className="w-full my-3 border-gray-300" />
                </div>
            );
        }

        return null;
    }

    const isNotOwner = ad.ad_user !== Window.user_data.loggedInUserID;
    const isTrustedBuyer = Window.react_data.trustedBuyer;
    return (
        <div className='mb-6 shadow p-6 flex flex-col justify-center bg-neutral-cloud' style={{ position: 'sticky', top: '80px', zIndex: 100, borderRadius: '12px' }}>
            {renderAdDetailsStateBar()}
            {renderAdsDetailsCTA()}
            {ad.auction_in_future && <div className='text-center font-medium fs-6'>
                Startdatum: {ad.start_time}
            </div>}
            {ad.auction_is_live && <div className='text-center items-center'>
                <div className='font-medium fs-6'>
                    {ad.days_left <= 1
                        ? `Timmar kvar: ${ad.hours_left}`
                        : `Dagar kvar: ${ad.days_left}`}
                </div>

                {ad.state_name !== "CREATED" && isNotOwner && <hr className="border-gray-300 my-3" />}

                {isNotOwner && isTrustedBuyer && (
                    <div className='w-full mt-6'>

                        {ad.attachments && (
                            <a
                                className="font-medium fs-7 ml-4"
                                style={{ cursor: 'pointer' }}
                                onClick={()=>(scrollCallback())}
                            >
                                Se viktiga bilagor
                            </a>
                        )}
                    </div>
                )}
            </div>}
            {ad.state_name === 'WAITING_FOR_REVIEW' && <p className="text-center mb-0 fs-7 leading-tight font-bold mb-4 mt-3">
                Just nu tittar våra specialister på din annons. Treebula kommer att godkänna annonsen eller kontakta dig vid behov komplettering.
            </p>}
            {createPortal(<>
                <TwModal isOpen={visiblePlaceBidModal} className="bg-neutral-cloud-300 z-[1110]">
                <TwModal.Header>
                        <div>
                            <p className="fs-5 font-medium mb-1">Ange anbud</p>
                            <p className="fs-7 neutral-pebble">Lägg till text eller ladda upp bilagor</p>
                        </div>
                        <Button
                            variant="tertiary"
                            size="icon"
                            onClick={() => setVisiblePlaceBidModal(false)}
                        >
                            <Icon
                                name="CrossSimple"
                                className="color-charcoal-500"
                                size="large"
                            />
                        </Button>
                </TwModal.Header>
                <TwModal.Content>
                    <div>
                        <VBTextarea height="128px" onChange={(txt) => { setBidText(txt) }}
                            placeholder="Lägg till text"
                            label={<p className="pb-2 font-medium fs-7">Ange anbudet i textformat här:</p>} />
                        <hr className="border-gray-300 my-3" />
                        <div className="w-full">
                            <p className='font-medium fs-7 mb-1'>Ladda upp anbudsbilagor</p>
                            <p className="fs-7 neutral-pebble">Ladda upp bilagor som du vill ha med i anbudet exempelvis prislistor.</p>
                            {tempFiles.map((file) => {
                                return <a className="bg-neutral-charcoal p-1 mr-1 white rounded-lg fs-8 inline-flex gap-2 items-center">
                                    {file.name}
                                    <img
                                        src={Window.static_path + 'img/icons/X.svg'}
                                        className='white-filter cursor-pointer w-3 h-3'
                                        role='button'
                                        onClick={() => {
                                            let files = tempFiles.filter(f => f !== file);
                                            if(!files){
                                                files = []
                                            }
                                            setTempFiles(files);
                                        }}
                                    />
                                </a>
                            })}
                        </div>
                        <label className="n-btn btn-forest-green btn-sm mt-6 inline-flex cursor-pointer"> <img className={`mr-2`} style={{ width: "18px", height: "18px" }} src={Window.static_path + "img/icons/icon-left.svg"} />Välj filer
                            <input onChange={handleUploadFiles} type="file" multiple style={{ display: "none" }} />
                        </label>
                    </div>
                </TwModal.Content>
                <TwModal.Footer className="flex justify-end">
                    <button className="n-btn btn-sm btn-forest-green btn-ghost cursor-pointer" onClick={() => setVisiblePlaceBidModal(false)}>Avbryt</button>
                    <button className="n-btn btn-sm btn-forest-green cursor-pointer flex items-center" onClick={() => { placeBid(); }}>Ja, Skicka anbud<span><img className={`ml-2 white-filter`} style={{ width: "16px", height: "16px" }} src={Window.static_path + "img/icons/arrow-black.svg"} /></span></button>
                </TwModal.Footer>
            </TwModal>
            <TwModal isOpen={visibleShowBidsModal} className="bg-neutral-cloud-300">
                <TwModal.Header>
                    <div className="flex justify-between items-start w-full">
                        <div>
                            <p className="fs-5 font-medium mb-1">Anbud på annons #{Window.react_data.ad.id}</p>
                            <p className="fs-7 neutral-pebble mb-0">Se anbud</p>
                        </div>
                        <Button
                            variant="tertiary"
                            size="icon"
                            onClick={() => setVisibleShowBidsModal(false)}
                        >
                            <Icon
                            name="CrossSimple"
                            className="color-charcoal-500"
                            size="large"
                            />
                        </Button>
                    </div>
                </TwModal.Header>
                <TwModal.Content>
                    <div className="flex flex-col gap-3">
                        {ad.bids_data.map((itm) => {
                            const isWinning = Window.react_data.ad.winning_bid_id === itm.id;
                            const isOpen = openBids.includes(itm.id);

                            return (
                                <div
                                    key={itm.id}
                                    className={`rounded-lg border overflow-hidden ${isWinning ? 'border-green-forest-green-400 border-l-4 border-l-green-forest-green-500 bg-white-50' : 'border-cloud-400 bg-white-50'}`}
                                >
                                    <button
                                        type="button"
                                        className="w-full p-4 flex justify-between items-center gap-2 text-left cursor-pointer"
                                        onClick={() => {
                                            setOpenBids(isOpen
                                                ? openBids.filter((id) => id !== itm.id)
                                                : [...openBids, itm.id]);
                                        }}
                                    >
                                        <p className="fs-6 font-medium mb-0">
                                            #{itm.id} – {itm.bid_user_name}
                                            {isWinning ? <span className="fs-8 ml-2 text-green-forest-green-500">(Vald köpare)</span> : null}
                                        </p>
                                        <Icon
                                            name="ChevronDownSimple"
                                            className={`shrink-0 fill-charcoal-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                                            size="large"
                                        />
                                    </button>
                                    {isOpen ? (
                                        <div className="px-4 pb-4 border-t border-cloud-400 pt-3">
                                            {itm.other_fields.map((f, i) => (
                                                <p key={i} className="fs-7 font-medium mb-1 break-words">
                                                    <span className="neutral-pebble">{f.label}:</span> {f.value}
                                                </p>
                                            ))}
                                            {itm.comments ? (
                                                <>
                                                    <p className="fs-7 pt-2 mb-1 font-medium">Kommentar</p>
                                                    <p className="fs-7 neutral-pebble whitespace-pre-line break-words mb-0">{itm.comments}</p>
                                                </>
                                            ) : null}
                                            {itm.attachments.length > 0 ? (
                                                <>
                                                    <p className="font-medium pt-2 mb-1">Bilagor</p>
                                                    <div className="flex flex-wrap gap-1">
                                                        {itm.attachments.map((attch, i) => (
                                                            <a
                                                                key={i}
                                                                className="bg-neutral-charcoal px-2 py-1 white rounded-md fs-8"
                                                                href={attch.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {attch.file_name}
                                                            </a>
                                                        ))}
                                                    </div>
                                                </>
                                            ) : null}
                                            {Window.react_data.ad.winning_bid_id === null && Window.react_data.ad.auction_is_over && ad.ad_user === Window.user_data.loggedInUserID ? (
                                                <div className="w-full flex justify-end pt-2">
                                                    <button type="button" className="n-btn btn-forest-green btn-sm cursor-pointer" onClick={() => selectWinningBid(itm.id)}>
                                                        Välj denna köpare
                                                    </button>
                                                </div>
                                            ) : null}
                                            {isWinning ? (
                                                <div className="w-full flex justify-end pt-2">
                                                    <span className="fs-7 font-medium text-green-forest-green-500">Vald som vinnare</span>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                            );
                        })}
                    </div>
                </TwModal.Content>
                <TwModal.Footer className="flex justify-end">
                    <button className="n-btn btn-forest-green btn-sm mt-2 cursor-pointer" onClick={() => setVisibleShowBidsModal(false)}>Stäng</button>
                </TwModal.Footer>
            </TwModal>
            <TwModal isOpen={showSellerContactModal} className="bg-neutral-cloud-300 z-[1110]">
                <TwModal.Header>
                    <div className="flex justify-between items-start w-full">
                        <p className="fs-5 font-medium">Kontaktuppgifter skogsägare</p>
                        <button type="button" className="ml-auto fs-5 leading-none cursor-pointer" onClick={() => setShowSellerContactModal(false)} aria-label="Close">&times;</button>
                    </div>
                </TwModal.Header>
                <TwModal.Content>
                    {ad.seller_contact ? (
                        <dl className="mb-0">
                            <dt className="fs-6 font-medium">Namn</dt>
                            <dd className="mb-3">{ad.seller_contact.full_name}</dd>
                            <dt className="fs-6 font-medium">E-post</dt>
                            <dd className="mb-3">
                                <a className="underline" href={`mailto:${ad.seller_contact.email}`}>{ad.seller_contact.email}</a>
                            </dd>
                            {ad.seller_contact.phone ? (
                                <>
                                    <dt className="fs-6 font-medium">Telefon</dt>
                                    <dd className="mb-0">
                                        <a className="underline" href={`tel:${String(ad.seller_contact.phone).replace(/\D/g, '')}`}>{ad.seller_contact.phone}</a>
                                    </dd>
                                </>
                            ) : null}
                        </dl>
                    ) : null}
                </TwModal.Content>
                <TwModal.Footer className="flex justify-end">
                    <Button
                        variant="primary"
                        onClick={() => setShowSellerContactModal(false)}
                    >
                        Stäng
                    </Button>
                </TwModal.Footer>
            </TwModal>
            
            </>, document.body)}
        </div>
    );

}
export default AdPlaceBidSection;